<template>
  <div :class="compact ? 'pl-3 border-left border-secondary' : ''">
    <div class="d-flex justify-content-start mb-2">
      <b-badge
        v-if="customer.merchant_type_name"
        pill
        variant="primary"
        :style="`font-size: ${compact ? '0.85rem' : '0.9rem'};`"
      >
        {{ customer.merchant_type_name.type_name }}
      </b-badge>
    </div>
    <div class="d-flex align-items-center mb-2">
      <i :class="`mdi mdi-account mr-2 ${compact ? 'text-muted' : ''}`"></i>
      <strong class="mr-2 info-label">姓名：</strong>
      <span>{{ customer.name }}</span>
    </div>
    <div class="d-flex align-items-center mb-2">
      <i :class="`mdi mdi-account-card-details mr-2 ${compact ? 'text-muted' : ''}`"></i>
      <strong class="mr-2 info-label">識別編號：</strong>
      <span>{{ customer.outer_code || '-' }}</span>
    </div>
    <div class="d-flex align-items-center mb-2">
      <i :class="`mdi mdi-cellphone mr-2 ${compact ? 'text-muted' : ''}`"></i>
      <strong class="mr-2 info-label">手機：</strong>
      <span>
        {{ customer.mobile_phone || '-' }}
        <span
          v-if="customer.phone_verified_at"
          class="mdi mdi-verified ml-1"
          style="color: #009100;"
        ></span>
      </span>
    </div>
    <div class="d-flex align-items-center mb-2">
      <i :class="`mdi mdi-account-check mr-2 ${compact ? 'text-muted' : ''}`"></i>
      <strong class="mr-2 info-label">註冊時間：</strong>
      <span>
        {{ customer.registered_at ? formatDate(customer.registered_at) : '-' }}
        <span
          v-if="customer.registered_at"
          class="mdi mdi-verified ml-1"
          style="color: #009100;"
        ></span>
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CustomerInfoCard',
  props: {
    customer: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm');
    },
  },
};
</script>

<style scoped>
.info-label {
  flex-shrink: 0;
}
</style>
